import HttpClient from './HttpClient.js';
import endpoints from './endpoints.js';
class IcecastServer {
    constructor(host, admin = {}) {
        (this.host = host), (this.admin = admin);
        this.httpClient = new HttpClient(host, admin);
    }
    async getStats() {
        const req = await this.httpClient.makeRequest(endpoints.getStats);
        const data = req?.icestats || JSON.parse(req?.replace('"title":-,', '"title":"-",'))?.icestats;
        if (data?.source) {
            data.source = Array.isArray(data.source)
                ? data.source.map((source) => {
                    const mount = `/${source?.listenurl?.split('/').pop()}`;
                    return {
                        mount,
                        ...source,
                    };
                })
                : {
                    mount: `/${data.source.listenurl.split('/').pop()}`,
                    ...data.source,
                };
        }
        return data;
    }
    async getSources() {
        const { source } = await this.getStats() || {};
        return source ? (Array.isArray(source) ? source : [source]) : null;
    }
    async getSource(mountpoint) {
        if (!mountpoint) {
            throw new Error('mountpoint required');
        }
        const sources = await this.getSources();
        const source = sources?.filter(source => source.mount === `/${mountpoint}`)?.[0] ?? null;
        if (!source) {
            throw new Error('source does not exist at mountpoint');
        }
        return source;
    }
    async updateSource(mountpoint, metadata) {
        if (!mountpoint) {
            throw new Error('mountpoint required');
        }
        if (!metadata) {
            throw new Error('metadata required');
        }
        const source = await this.getSource(mountpoint);
        const params = {
            mount: `/${mountpoint}`,
            mode: 'updinfo',
            song: metadata,
        };
        /* 3825 character limit */
        const data = await this.httpClient.makeRequest(endpoints.updateSource, { params });
        const response = data.status === 200 ? { ...source, ...(metadata && { title: metadata }) } : data;
        return response;
    }
}
export default IcecastServer;
